import React from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import moment from 'moment-timezone';

import _ from 'lodash';

import Dropzone from 'react-dropzone';

import { ComboBox } from 'office-ui-fabric-react/lib/ComboBox';
import {
  Dialog,
  DialogType,
  DialogFooter,
} from 'office-ui-fabric-react/lib/Dialog';
import {
  PrimaryButton,
  DefaultButton,
} from 'office-ui-fabric-react/lib/Button';
import {
  MessageBar,
  MessageBarType,
} from 'office-ui-fabric-react/lib/MessageBar';

import { localizable } from 'components/Localization';
import BaseSaleFormComponent from 'components/SaleForm/BaseSaleFormComponent';
import Doc from './Doc';
import DatePicker from 'components/DatePicker';
import DocRequiredInfo from './DocRequiredInfo';

@localizable
@observer
class Page3 extends BaseSaleFormComponent {
  @observable currentDoc = {};

  @observable dropzoneState = {
    active: false,
    uploadInProgress: false,
  };

  dropzoneRef;

  @observable uploadErrors = [];

  customFileName(name) {
    return name
      .toLowerCase()
      .replace('ä', 'ae')
      .replace('ö', 'oe')
      .replace('ü', 'ue')
      .replace('ß', 'ss')
      .normalize('NFD')
      .replace(/[\s]+/g, '_')
      .replace(/[^\w0-9_]+/g, '');
  }

  applyFileCopyData(doc, type) {
    const t = this.props.t;
    Object.assign(doc, {
      type: type,
      short: t(`documenttype::${type}`),
      full: t(`documenttype::${type}_long`, {}, `documenttype::${type}`),
      fileName: this.customFileName(type),
    });
  }

  // onDragEnter() {
  //   this.dropzoneState.active = true;
  // }

  // onDragLeave() {
  //   this.dropzoneState.active = false;
  // }

  // onDrop(files) {
  //   this.dropzoneState.active = false;
  // }

  setDocType(option, _, value) {
    this.currentDoc.type = option ? option.key : value;
    this.applyFileCopyData(this.currentDoc, option ? option.key : value);
  }

  setDocDetail(value) {
    this.currentDoc.details = value;
  }

  selectDoc(d) {
    this.currentDoc = Object.assign({}, d);
  }

  updateDoc() {
    var { docs } = this.props;
    var d = _.find(docs, (d) => d.id === this.currentDoc.id);
    if (d) {
      Object.assign(d, this.currentDoc);
    }
    this.currentDoc = {};
  }

  isValid = () => {
    var { docs } = this.props;
    return !_.some(docs, (d) => !d.type);
  };

  cancelDoc() {
    this.currentDoc = {};
  }

  itemHandlers = {
    handleDelete: (d) => async () => {
      var { docs, deleteDoc } = this.props;

      if (d.metadata && d.metadata.deleteToken) {
        deleteDoc(d.metadata.deleteToken);
      }

      docs.splice(docs.indexOf(d), 1);
    },

    handleEdit: (d) => () => {
      this.selectDoc(d);
    },

    handleMoveUp: (d) => () => {
      var { docs } = this.props;
      var index = docs.indexOf(d);
      if (index <= 0) return;

      docs[index] = docs[index - 1];
      docs[index - 1] = d;
    },

    handleMoveDown: (d) => () => {
      var { docs } = this.props;
      var index = docs.indexOf(d);
      if (index >= docs.length - 1) return;

      docs[index] = docs[index + 1];
      docs[index + 1] = d;
    },
  };

  async handleUpload(files) {
    var { uploadDoc, docs } = this.props;

    this.uploadErrors.clear();

    this.dropzoneState.uploadInProgress = true;

    for (var file of files) {
      try {
        var uploaded = await uploadDoc(file);
        docs.push(uploaded);
      } catch (error) {
        this.uploadErrors.push({ file, error: this.parseUploadError(error) });
      }
    }

    this.dropzoneState.uploadInProgress = false;
  }

  parseUploadError(error) {
    var { t } = this.props;
    if (
      typeof error.response !== 'undefined' &&
      typeof error.response.error !== 'undefined' &&
      typeof error.response.error.message !== 'undefined'
    ) {
      // try to detect known errors
      var res = /Raw file format ([^\s]+) not allowed/i.exec(
        error.response.error.message
      );
      if (res !== null)
        return t('File extension is not supported', { extension: res[1] });
      res = /File size too large. Got ([\d]+). Maximum is ([\d]+)/i.exec(
        error.response.error.message
      );
      if (res !== null)
        return t('File size exceeds allowed limit', {
          size: res[1],
          allowed: res[2],
        });
      // no luck, use the raw error message from Cloudinary
      return error.response.error.message;
    }
    // fallback to the error object
    return error;
  }

  formatDate = (date) => {
    return !!date ? date.toFormatedDateString('L') : null;
  };

  parseDateFromString = (value) => {
    return !!value ? moment(value, 'L').toDate() : value;
  };

  render() {
    var { sale, offerData, docs, t, config } = this.props;

    return (
      <Dropzone
        disableClick
        className="ms-Grid"
        ref={(node) => {
          this.dropzoneRef = node;
        }}
        accept="image/jpeg, application/pdf, image/png"
        onDrop={this.handleUpload.bind(this)}
      >
        <div className="ms-Grid-row">
          <h3 className="ms-Grid-col ms-lg12">{t('Documents')}</h3>
        </div>

        <DocRequiredInfo
          sale={sale}
          offerData={offerData}
          docs={docs}
          t={t}
          config={config}
        />

        {docs &&
          docs.map((d, i) => (
            <Doc key={d.id} d={d} i={i} {...this.itemHandlers} />
          ))}

        {!this.isValid() && (
          <MessageBar messageBarType={MessageBarType.error}>
            {t('All documents must have a type set')}
          </MessageBar>
        )}

        <div
          className="ms-Grid-row"
          style={{ marginTop: '0.5em', marginBottom: '0.5em' }}
        >
          <div className="ms-Grid-col ms-lg12">
            <PrimaryButton
              disabled={this.dropzoneState.uploadInProgress}
              onClick={() => this.dropzoneRef.open()}
            >
              {this.dropzoneState.uploadInProgress
                ? t('Uploading') + '...'
                : docs && docs.length > 0
                  ? t('Upload more')
                  : t('Upload')}
            </PrimaryButton>
            <div className="ms-font-xs" style={{ paddingTop: '0.5em' }}>
              {t('Allowed file formats')}
            </div>
          </div>
        </div>

        {this.uploadErrors.length > 0 && (
          <MessageBar messageBarType={MessageBarType.error}>
            {this.uploadErrors.map((error) => (
              <div key={error.file.name}>
                <strong>{error.file.name}</strong>: {error.error}
              </div>
            ))}
          </MessageBar>
        )}

        <Dialog
          hidden={!this.currentDoc.id}
          onDismiss={this._closeDialog}
          dialogContentProps={{
            type: DialogType.largeHeader,
            title: t('Edit'),
          }}
          modalProps={{
            isBlocking: true,
          }}
        >
          <form>
            <p>{t('Choose a document type or enter description')}:</p>

            <ComboBox
              label={t('Document type')}
              name="type"
              allowFreeform={true}
              autoComplete="on"
              onChanged={this.setDocType.bind(this)}
              value={
                this.currentDoc.type
                  ? t(
                    `documenttype::${this.currentDoc.type}_long`,
                    {},
                    `documenttype::${this.currentDoc.type}`
                  )
                  : ''
              }
              options={[{ key: '', text: '' }].concat(
                this.props.documentTypes.map((key) => {
                  return {
                    key: key,
                    text: t(
                      `documenttype::${key}_long`,
                      {},
                      `documenttype::${key}`
                    ),
                  };
                })
              )}
            />

            <DatePicker
              label={t('Date')}
              allowTextInput={true}
              value={
                this.currentDoc.details
                  ? new Date(this.currentDoc.details)
                  : null
              }
              onSelectDate={this.setDocDetail.bind(this)}
              formatDate={this.formatDate}
              parseDateFromString={this.parseDateFromString}
            />

            <DialogFooter>
              <PrimaryButton
                onClick={this.updateDoc.bind(this)}
                text={t('Save')}
              />
              <DefaultButton
                onClick={this.cancelDoc.bind(this)}
                text={t('Cancel')}
              />
            </DialogFooter>
          </form>
        </Dialog>
      </Dropzone>
    );
  }
}

export default Page3;



// WEBPACK FOOTER //
// ./src/app/containers/Sale/SaleEditSection/Page3.jsx